import { api } from '../../config/api'
import {
  OTOP,
  POPULAR_OTOP,
  OTOP_DETAILS,
  OTOP_ADD_TO_CART,
  OTOP_REMOVE_FROM_CART,
  OTOP_CHECKOUT
} from '../../actions/actionTypes'

export const getOtop = () => (dispatch, getState) => {
  const { lang, lasted } = getState()
  if (lasted !== getState().otop.list[lang].lastUpdate || !getState().otop.list[lang].data.length) {
    dispatch({ type: OTOP.REQUEST })
    return (
      fetch(api.otop+'?language='+lang)
      .then(res => res.json())
      .then((res) => {
        dispatch({ type: OTOP.SUCCESS, data: res, lang, lasted })
      })
      .catch((err) => {
        dispatch({ type: OTOP.FAILURE, error: err })
      })
    )
  }
}

export const getPoppularOtop = () => (dispatch, getState) => {
  const { lang, lasted } = getState()
  if (lasted !== getState().otop.popular[lang].lastUpdate || !getState().otop.popular[lang].data.length) {
    dispatch({ type: POPULAR_OTOP.REQUEST })
    return (
      fetch(api.otopPopular+'?language='+lang)
      .then(res => res.json())
      .then((res) => {
        dispatch({ type: POPULAR_OTOP.SUCCESS, data: res, lang, lasted })
      })
      .catch((err) => {
        dispatch({ type: POPULAR_OTOP.FAILURE, error: err })
      })
    )
  }
}

export const getOtopDataById = (id) => (dispatch, getState) => {
  const { lang, lasted } = getState()
  dispatch({ type: OTOP_DETAILS.REQUEST, lang })
  return (
    fetch(api.otop+'/'+id+'?language='+lang)
    .then(res => res.json())
    .then((res) => {
      dispatch({ type: OTOP_DETAILS.SUCCESS, data: res, lang, lasted })
    })
    .catch((err) => {
      dispatch({ type: OTOP_DETAILS.FAILURE, error: err })
    })
  )
}

export const addToCart = (id) => ({
  type: OTOP_ADD_TO_CART,
  id
})
export const removeFromCart = (id) => ({
  type: OTOP_REMOVE_FROM_CART,
  id
})
export const checkout = (data) => (dispatch, getState) => {
  const {
    name,
    tel,
    email,
    address,
  } = data
  const cartList = getState().otop.cart.cart
  dispatch({ type: OTOP_CHECKOUT.REQUEST })
  return fetch(api.otopCheckoutCart, {
    method: 'POST',
    headers: {
      "content-type": "application/x-www-form-urlencoded"
    },
    body: JSON.stringify({
      name,
      tel,
      email,
      address,
      date: Date.now(),
      otops: cartList,
      note: '' // not sure from wireframe
    })
  })
  .then((res) => res.json())
  .then((res) => {
    dispatch({ type: OTOP_CHECKOUT.SUCCESS, data: res })
  })
  .catch((err) => {
    dispatch({ type: OTOP_CHECKOUT.FAILURE, error: err })
  })
}


// WEBPACK FOOTER //
// ./src/containers/Otop/actions.js